import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { addUnit } from '@/shared/util';
var __default__ = {
    name: 'XFontIcon',
    inheritAttrs: false
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    props: {
        name: String,
        dot: Boolean,
        badge: [
            Number,
            String
        ],
        color: String,
        size: [
            Number,
            String
        ],
        tag: {
            type: String,
            default: 'i'
        }
    },
    setup: function setup(__props) {
        var props = __props;
        var isImageIcon = computed(function() {
            return props.name ? props.name.includes('/') : false;
        });
        return {
            __sfc: true,
            props: props,
            isImageIcon: isImageIcon,
            addUnit: addUnit
        };
    }
}));
